import { Box, Stack, Typography, CardMedia, Grid } from "@mui/material";

// CSS
import "./KeywordReportImage.css";

interface propsType {
  brief: any;
  index: number;
}

const KeywordReportImage = (props: propsType) => {
  return (
    <Grid key={`image-list-${props.brief.sk}-${props.index}`} item xs={6} md={6} lg={4} xl={4}>
      <Stack direction={"column"} spacing={0}>
        <Box>
          {props.brief.image_list[0] 
          ? <CardMedia
              component={"img"}
              image={props.brief.image_list[0]}
              sx={{ height: "180px", width: "100%", objectFit: "cover" }}
              onError={(e) => {
                e.currentTarget.src = "/images/no-image.png";
                e.currentTarget.className = "noImage";
              }}
            />
          :
            <Box sx={{ 
              display: "flex",
              justifyContent: "center",
              height: "180px", 
              width: "100%", 
              backgroundColor: "rgba(232, 232, 232, 1)" 
            }}>
              <img 
                src="/images/no-image.png" 
                className="noImage"
                style={{ objectFit: "cover" }}
              />
            </Box>
          }
        </Box>
        <Box>
          <Typography sx={{ fontSize: "1rem", fontWeight: "700", lineHeight: "21px", mt: 1 }}>
            {String(props.index + 1).padStart(2, "0")}
          </Typography>
        </Box>
      </Stack>
    </Grid>
  );
};

export default KeywordReportImage;
